var themeOptions = function () { return ({
    components: {
        MuiFormGroup: {
            styleOverrides: {
                root: {
                    gap: '4px',
                },
            },
        },
    },
}); };
export default themeOptions;
//# sourceMappingURL=formGroupTheme.js.map